const printButtons = document.getElementsByClassName( 'js-print-button' );

Array.prototype.forEach.call( printButtons, function ( printButton ) {
	printButton.addEventListener( 'click', function () {
		window.print();
	} );
} );
